import { RouteConfig } from "vue-router";
// @ts-ignore
import { Permission } from "@/enums/Permission";
import { PermissionHelper } from "@/classes/PermissionHelper";
import CreditList from "@/views/shortCredit/credit-list.vue";
import ShortCredit from "@/views/shortCredit/index.vue";
import CollectionList from "@/views/shortCredit/collection/index.vue";
// Redirect to user's authorized (has permission) tab
function redirectToUserAuthorizedRoute() {
    return '/short-credit/' + PermissionHelper([
        Permission.VIEW_REQUESTED_SHORT_CREDIT,
        Permission.VIEW_APPROVED_SHORT_CREDIT,
        Permission.VIEW_SHORT_CREDIT_COLLECTION,
    ], [{ permission: Permission.VIEW_REQUESTED_SHORT_CREDIT, name: 'requested' },
        { permission: Permission.VIEW_APPROVED_SHORT_CREDIT, name: 'approved' },
        { permission: Permission.VIEW_SHORT_CREDIT_COLLECTION, name: 'collection' },
    ]);
}

const PaymentRoutes: RouteConfig = {
    path: 'short-credit',
    components: {dashboard: ShortCredit},
    name: 'short-credit',
    redirect: to => {
        return redirectToUserAuthorizedRoute();
    },
    children: [
        {
            path: '/short-credit/requested',
            name: 'requested',
            meta: {
                label: 'Requested',
                icon: 'fas fa-wallet',
                permission: Permission.VIEW_REQUESTED_SHORT_CREDIT,
                breadCrumb: 'short credit'
            },
            component: CreditList
        },
        {
            path: '/short-credit/approved',
            name: 'approved',
            meta: {
                label: 'Approved',
                icon: 'fas fa-wallet',
                permission: Permission.VIEW_APPROVED_SHORT_CREDIT,
                breadCrumb: 'short credit'
            },
            component: CreditList,
        },
        {
            path: '/short-credit/collection',
            name: 'collection',
            meta: {
                label: 'Collection',
                icon: 'fas fa-wallet',
                permission: Permission.VIEW_SHORT_CREDIT_COLLECTION,
                breadCrumb: 'short credit'
            },
            component: CollectionList,
        },
    ]
};
export default PaymentRoutes;
